import {
  SubmitMyProfileAndAnswersRequestDto,
  useSubmitMyProfileAndAnswers,
} from "@/api/user/useSubmitMyProfileAndAnswers";
import { useAuth } from "@/auth/AuthContext";
import {
  getPersonalityTestFormData,
  hasPersonalityTestFormData,
  removePersonalityTestFormData,
} from "@/components/PersonalityTest/personalityTestStorage";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useSubmitPreviouslySubmittedAnswers = () => {
  const { user } = useAuth();
  const { mutateAsync: submitPersonalityTest } = useSubmitMyProfileAndAnswers();
  const navigate = useNavigate();
  const hasStartedSubmission = useRef(false);

  const userHasPreviouslySubmittedPersonalityTest = useMemo(() => {
    return hasPersonalityTestFormData() && !!user;
  }, [user]);

  const [isSubmittingPreviousAnswers, setIsSubmittingPreviousAnswers] = useState(
    userHasPreviouslySubmittedPersonalityTest
  );

  const handleSubmit = useCallback(async () => {
    if (hasStartedSubmission.current) {
      return;
    }

    hasStartedSubmission.current = true;
    setIsSubmittingPreviousAnswers(true);

    const savedData = getPersonalityTestFormData();
    if (savedData) {
      try {
        await submitPersonalityTest(savedData as unknown as SubmitMyProfileAndAnswersRequestDto);
        removePersonalityTestFormData();
        navigate("/home");
      } catch (error) {
        console.error("Error submitting previously submitted answers:", error);
        // On error, stop submitting and show the test so the user can try again.
        setIsSubmittingPreviousAnswers(false);
        removePersonalityTestFormData();
        hasStartedSubmission.current = false;
      }
    }
  }, [submitPersonalityTest, navigate]);

  useEffect(() => {
    if (userHasPreviouslySubmittedPersonalityTest && !hasStartedSubmission.current) {
      handleSubmit();
    }
  }, [userHasPreviouslySubmittedPersonalityTest, handleSubmit]);

  return { isSubmittingPreviousAnswers };
};
